/**
 * Formats a phone number string to (123) 456-7890 format
 * @param phoneNumber - Phone number string (can be formatted or unformatted)
 * @returns Formatted phone number string
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-digit characters
  const digits = phoneNumber.replace(/\D/g, '');

  // Format based on length
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

/**
 * Parses a formatted phone number string to digits only
 * @param phoneNumber - Formatted phone number string
 * @returns Phone number with only digits (max 10 digits)
 */
export const parsePhoneNumber = (phoneNumber: string): string => {
  // Remove all non-digit characters and limit to 10 digits
  return phoneNumber.replace(/\D/g, '').slice(0, 10);
};
